import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import {Divider, FormControl, Select} from "@mui/material";
import {useDeck} from "../../deck-management/context/DeckContext";


export default function DeckSelectionDropdownView() {

    const { allDecks, currentDeck, changeCurrentDeck, ready } = useDeck();

    if (!ready) {
        return null;
    }

    return (
        <FormControl sx={{ml: 1}}>
            <Select
                value={currentDeck!.deckId}
                sx={{fontSize: 18, boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 }}}
                onChange={(e) => {
                        changeCurrentDeck(allDecks!.find(deck => deck.deckId === e.target.value)!);
                }}
                MenuProps={{
                    disableScrollLock: true,
                }}
            >
                {allDecks!.map(deck => <MenuItem key={deck.deckId} value={deck.deckId}>{deck.language}</MenuItem>)}
                <Divider/>
            </Select>
        </FormControl>
    );
}
